import React, { useEffect, useState } from 'react'
import * as MdIcons from 'react-icons/md';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import axios from 'axios';

const REACT_APP_API_URL = process.env.REACT_APP_API_URL

const ManageCareer = () => {

    const [Career, setCareer] = useState({
        name: "",
        jobType: "",
        department: "",
        experience: "",
        location: "",
        postedDate: "",
        applyEndDate: "",
        description: "",
        responsibilities: "",
        requirements: "",
        benefits: "",
        show: false
    })

    const [AllCareerData, setAllCareerData] = useState([])
    const [buttonType, setbuttonType] = useState("ADD")
    const [showModal, setShowModal] = useState(false);
    const [isClosing, setIsClosing] = useState(false);
    const [loading, setLoading] = useState(false);
    const [viewCareer, setViewCareer] = useState(null);

    const [showSidebar, setShowSidebar] = useState(false);

    // Application Management State
    const [viewMode, setViewMode] = useState('jobs'); // 'jobs' or 'applications'
    const [applications, setApplications] = useState([]);


    const handleChange = (e) => {
        setCareer({ ...Career, [e.target.name]: e.target.value })
    }

    const handleCheckBox = (e) => {
        setCareer({ ...Career, [e.target.name]: !(Career.show) })
    }

    const handleShowData = async (job) => {
        try {
            const updatedJob = { ...job, show: !job.show };
            const response = await axios.put(
                `${REACT_APP_API_URL}/admin/managecareer/updatejob/${job._id}`,
                updatedJob
            );

            if (response.data.success) {
                GetJobs();
            }
        } catch (error) {
            console.error("Error updating job status:", error);
        }
    }

    const handleAddCareer = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            if (buttonType === "UPDATE") {
                const response = await axios.put(
                    `${REACT_APP_API_URL}/admin/managecareer/updatejob/${Career._id}`,
                    Career,
                    { withCredentials: true }
                );

                console.log("Update Response:", response.data); // Debug log

                if (response.data.success) {
                    alert(response.data.message);
                    GetJobs();
                    closeModal();
                    resetForm();
                } else {
                    alert(response.data.message || "Failed to update job");
                }
            } else {
                const response = await axios.post(
                    `${REACT_APP_API_URL}/admin/managecareer/addjob`,
                    Career,
                    { withCredentials: true }
                );

                console.log("Add Response:", response.data); // Debug log

                if (response.data.success) {
                    alert(response.data.message);
                    GetJobs();
                    closeModal();
                    resetForm();
                } else {
                    alert(response.data.message || "Failed to add job");
                }
            }
        } catch (error) {
            console.error("Error in Career API:", error);
            console.error("Error details:", error.response?.data); // Debug log
            alert(error.response?.data?.message || "Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    }

    const resetForm = () => {
        setCareer({
            name: "",
            jobType: "",
            department: "",
            experience: "",
            location: "",
            postedDate: "",
            applyEndDate: "",
            description: "",
            responsibilities: "",
            requirements: "",
            benefits: "",
            show: false
        });
        setbuttonType("ADD");
    }

    const handleEditCareer = (job) => {
        setCareer(job);
        openModal();
        setbuttonType("UPDATE");
    }

    const handleViewCareer = (job) => {
        setViewCareer(job);
        setShowSidebar(true);
    }

    const openModal = () => {
        setShowModal(true);
        setIsClosing(false);
    };

    const closeModal = () => {
        setIsClosing(true);
        setTimeout(() => {
            setShowModal(false);
            resetForm();
        }, 300);
    };

    const GetJobs = async () => {
        try {
            const response = await axios.get(`${REACT_APP_API_URL}/admin/managecareer/getjobs`, {
                withCredentials: true
            });
            console.log("API Response:", response.data); // Debug log
            setAllCareerData(response.data.data || response.data.response || []);
        } catch (error) {
            console.error("Error in Get Jobs API:", error);
            alert("Failed to fetch jobs. Please try again.");
        }
    }

    const GetApplications = async () => {
        try {
            const response = await axios.get(`${REACT_APP_API_URL}/admin/managecareer/applications`, {
                withCredentials: true
            });
            if (response.data.success) {
                setApplications(response.data.response);
            }
        } catch (error) {
            console.error("Error fetching applications:", error);
        }
    }

    const DeleteApplication = async (id) => {
        if (window.confirm("Are you sure you want to delete this application?")) {
            try {
                const response = await axios.delete(`${REACT_APP_API_URL}/admin/managecareer/application/${id}`, {
                    withCredentials: true
                });
                if (response.data.success) {
                    alert("Application deleted successfully");
                    GetApplications();
                } else {
                    alert("Failed to delete application");
                }
            } catch (error) {
                console.error("Error deleting application:", error);
                alert("Error deleting application");
            }
        }
    }

    useEffect(() => {
        if (viewMode === 'applications') {
            GetApplications();
        } else {
            GetJobs();
        }
    }, [viewMode]);

    const DeleteJob = async (job) => {
        if (window.confirm(`Are you sure you want to delete "${job.name}"?`)) {
            try {
                const response = await axios.delete(
                    `${REACT_APP_API_URL}/admin/managecareer/deletejob/${job._id}`
                );

                if (response.data.success) {
                    alert("Job deleted successfully");
                    GetJobs();
                }
            } catch (error) {
                console.error("Error in Deleting Job:", error);
                alert("Failed to delete job");
            }
        }
    }

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    }

    useEffect(() => {
        GetJobs();
    }, [])

    return (
        <>
            {/* Header */}
            <div className="bg-white rounded-admin shadow-admin p-6 mb-6 flex flex-col md:flex-row justify-between items-center gap-4">
                <div>
                    <h2 className="text-3xl font-bold text-gray-800">Manage Careers</h2>
                    <p className="text-gray-600 mt-1">Add and manage job openings and applications</p>
                </div>
                <div className="flex bg-gray-100 p-1 rounded-lg">
                    <button
                        className={`px-6 py-2 rounded-md font-semibold transition-all ${viewMode === 'jobs' ? 'bg-white text-primary shadow-sm' : 'text-gray-600 hover:text-gray-800'}`}
                        onClick={() => setViewMode('jobs')}
                    >
                        Job Listings
                    </button>
                    <button
                        className={`px-6 py-2 rounded-md font-semibold transition-all ${viewMode === 'applications' ? 'bg-white text-primary shadow-sm' : 'text-gray-600 hover:text-gray-800'}`}
                        onClick={() => setViewMode('applications')}
                    >
                        Applications
                    </button>
                </div>
                {viewMode === 'jobs' && (
                    <button
                        className="bg-primary hover:bg-primary-600 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-200 flex items-center gap-2 shadow-md hover:shadow-lg"
                        onClick={openModal}
                    >
                        <AiIcons.AiOutlinePlus size={20} />
                        Add New Job
                    </button>
                )}
            </div>

            {viewMode === 'applications' ? (
                <div className="bg-white rounded-admin shadow-admin overflow-hidden">
                    <div className="p-4 border-b">
                        <h3 className="text-xl font-bold text-gray-800">Received Applications ({applications.length})</h3>
                    </div>
                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead className="bg-gray-50 text-gray-700">
                                <tr>
                                    <th className="px-6 py-4 text-left text-sm font-semibold">Job Role</th>
                                    <th className="px-6 py-4 text-left text-sm font-semibold">Candidate</th>
                                    <th className="px-6 py-4 text-left text-sm font-semibold">Contact</th>
                                    <th className="px-6 py-4 text-left text-sm font-semibold">Experience</th>
                                    <th className="px-6 py-4 text-left text-sm font-semibold">Resume</th>
                                    <th className="px-6 py-4 text-left text-sm font-semibold">Date</th>
                                    <th className="px-6 py-4 text-left text-sm font-semibold">Actions</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200">
                                {applications.length > 0 ? applications.map((app, i) => (
                                    <tr key={i} className="hover:bg-gray-50">
                                        <td className="px-6 py-4">
                                            <div className="font-semibold text-gray-900">{app.jobName}</div>
                                            <div className="text-xs text-gray-500">ID: {app.jobId?._id || 'N/A'}</div>
                                        </td>
                                        <td className="px-6 py-4">
                                            <div className="font-semibold text-gray-900">{app.name}</div>
                                            <a href={app.linkedIn} target="_blank" rel="noreferrer" className="text-blue-600 text-xs hover:underline">LinkedIn Profile</a>
                                        </td>
                                        <td className="px-6 py-4">
                                            <div className="text-sm text-gray-900">{app.email}</div>
                                            <div className="text-sm text-gray-500">{app.phone}</div>
                                        </td>
                                        <td className="px-6 py-4">
                                            <div className="text-sm text-gray-900">{app.experience}</div>
                                            <div className="text-xs text-gray-500">{app.currentCompany}</div>
                                        </td>
                                        <td className="px-6 py-4">
                                            {app.resume ? (
                                                <a
                                                    href={`${process.env.REACT_APP_API_URL}/uploads/${app.resume}`}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className="inline-flex items-center gap-1 text-blue-600 hover:text-blue-800 bg-blue-50 px-3 py-1 rounded-full text-sm font-medium"
                                                >
                                                    <FaIcons.FaFileDownload size={12} /> View Resume
                                                </a>
                                            ) : (
                                                <span className="text-gray-400 text-sm">No Resume</span>
                                            )}
                                        </td>
                                        <td className="px-6 py-4 text-sm text-gray-500">
                                            {new Date(app.createdAt).toLocaleDateString()}
                                        </td>
                                        <td className="px-6 py-4">
                                            <button
                                                onClick={() => DeleteApplication(app._id)}
                                                className="text-red-600 hover:text-red-800 p-2 hover:bg-red-50 rounded-full transition-colors"
                                                title="Delete Application"
                                            >
                                                <MdIcons.MdOutlineDeleteForever size={20} />
                                            </button>
                                        </td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colspan="6" className="text-center py-8 text-gray-500">
                                            No applications received yet.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            ) : (
                <>
                    {/* Job Stats & Table Content */}

                    {/* Stats Cards */}
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
                        <div className="bg-white rounded-admin shadow-admin p-6">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-gray-600 text-sm">Total Jobs</p>
                                    <h3 className="text-2xl font-bold text-gray-800 mt-1">{AllCareerData.length}</h3>
                                </div>
                                <div className="bg-blue-100 p-3 rounded-lg">
                                    <FaIcons.FaBriefcase className="text-blue-600" size={24} />
                                </div>
                            </div>
                        </div>
                        <div className="bg-white rounded-admin shadow-admin p-6">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-gray-600 text-sm">Active Jobs</p>
                                    <h3 className="text-2xl font-bold text-green-600 mt-1">
                                        {AllCareerData.filter(job => job.show).length}
                                    </h3>
                                </div>
                                <div className="bg-green-100 p-3 rounded-lg">
                                    <AiIcons.AiOutlineCheckCircle className="text-green-600" size={24} />
                                </div>
                            </div>
                        </div>
                        <div className="bg-white rounded-admin shadow-admin p-6">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-gray-600 text-sm">Inactive Jobs</p>
                                    <h3 className="text-2xl font-bold text-orange-600 mt-1">
                                        {AllCareerData.filter(job => !job.show).length}
                                    </h3>
                                </div>
                                <div className="bg-orange-100 p-3 rounded-lg">
                                    <AiIcons.AiOutlinePauseCircle className="text-orange-600" size={24} />
                                </div>
                            </div>
                        </div>
                        <div className="bg-white rounded-admin shadow-admin p-6">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-gray-600 text-sm">Departments</p>
                                    <h3 className="text-2xl font-bold text-purple-600 mt-1">
                                        {new Set(AllCareerData.map(job => job.department)).size}
                                    </h3>
                                </div>
                                <div className="bg-purple-100 p-3 rounded-lg">
                                    <FaIcons.FaLayerGroup className="text-purple-600" size={24} />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Table */}
                    <div className="bg-white rounded-admin shadow-admin overflow-hidden">
                        <div className="overflow-x-auto">
                            <table className="w-full">
                                <thead className="bg-gradient-to-r from-primary to-primary-600 text-white">
                                    <tr>
                                        <th className="px-6 py-4 text-left text-sm font-semibold">Sr.</th>
                                        <th className="px-6 py-4 text-left text-sm font-semibold">Job Title</th>
                                        <th className="px-6 py-4 text-left text-sm font-semibold">Department</th>
                                        <th className="px-6 py-4 text-left text-sm font-semibold">Type</th>
                                        <th className="px-6 py-4 text-left text-sm font-semibold">Experience</th>
                                        <th className="px-6 py-4 text-left text-sm font-semibold">Location</th>
                                        <th className="px-6 py-4 text-left text-sm font-semibold">Posted Date</th>
                                        <th className="px-6 py-4 text-left text-sm font-semibold">End Date</th>
                                        <th className="px-6 py-4 text-center text-sm font-semibold">Status</th>
                                        <th className="px-6 py-4 text-center text-sm font-semibold">Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200">
                                    {AllCareerData && AllCareerData.map((job, i) => (
                                        <tr key={i} className="hover:bg-gray-50 transition-colors duration-150">
                                            <td className="px-6 py-4 text-sm font-medium text-gray-900">{i + 1}</td>
                                            <td className="px-6 py-4">
                                                <div className="font-semibold text-gray-900">{job.name}</div>
                                            </td>
                                            <td className="px-6 py-4">
                                                <span className="text-sm text-gray-700">{job.department || '-'}</span>
                                            </td>
                                            <td className="px-6 py-4">
                                                <span className="px-3 py-1 rounded-full text-xs font-semibold bg-blue-100 text-blue-800">
                                                    {job.jobType}
                                                </span>
                                            </td>
                                            <td className="px-6 py-4 text-sm text-gray-700">{job.experience}</td>
                                            <td className="px-6 py-4 text-sm text-gray-700">{job.location}</td>
                                            <td className="px-6 py-4 text-sm text-gray-700">{formatDate(job.postedDate)}</td>
                                            <td className="px-6 py-4 text-sm text-gray-700">{formatDate(job.applyEndDate)}</td>
                                            <td className="px-6 py-4 text-center">
                                                <label className="relative inline-flex items-center cursor-pointer">
                                                    <input
                                                        type="checkbox"
                                                        className="sr-only peer"
                                                        checked={job.show}
                                                        onChange={() => handleShowData(job)}
                                                    />
                                                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-500"></div>
                                                </label>
                                            </td>
                                            <td className="px-6 py-4">
                                                <div className="flex items-center justify-center gap-3">
                                                    <button
                                                        onClick={() => handleViewCareer(job)}
                                                        className="text-blue-600 hover:text-blue-800 transition-colors p-2 hover:bg-blue-50 rounded-lg"
                                                        title="View Details"
                                                    >
                                                        <FaIcons.FaRegEye size={18} />
                                                    </button>
                                                    <button
                                                        onClick={() => handleEditCareer(job)}
                                                        className="text-green-600 hover:text-green-800 transition-colors p-2 hover:bg-green-50 rounded-lg"
                                                        title="Edit"
                                                    >
                                                        <FaIcons.FaEdit size={18} />
                                                    </button>
                                                    <button
                                                        onClick={() => DeleteJob(job)}
                                                        className="text-red-600 hover:text-red-800 transition-colors p-2 hover:bg-red-50 rounded-lg"
                                                        title="Delete"
                                                    >
                                                        <MdIcons.MdOutlineDeleteForever size={20} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {AllCareerData.length === 0 && (
                                <div className="text-center py-12">
                                    <FaIcons.FaBriefcase className="mx-auto text-gray-400 mb-4" size={48} />
                                    <p className="text-gray-500 text-lg">No jobs found. Add your first job posting!</p>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Modal */}
                    {showModal && (
                        <div className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 ${isClosing ? 'animate-fadeOut' : 'animate-fadeIn'}`}>
                            <div className={`bg-white rounded-2xl shadow-2xl w-full max-w-3xl max-h-[90vh] overflow-y-auto ${isClosing ? 'animate-slideDown' : 'animate-slideUp'}`}>
                                <div className="sticky top-0 bg-gradient-to-r from-primary to-primary-600 text-white p-6 rounded-t-2xl flex justify-between items-center">
                                    <h3 className="text-2xl font-bold">
                                        {buttonType === "UPDATE" ? "Update Job" : "Add New Job"}
                                    </h3>
                                    <button
                                        onClick={closeModal}
                                        className="text-white hover:bg-white hover:bg-opacity-20 rounded-full p-2 transition-all"
                                    >
                                        <AiIcons.AiOutlineClose size={24} />
                                    </button>
                                </div>

                                <form onSubmit={handleAddCareer} className="p-6 space-y-4">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div className="md:col-span-2">
                                            <label className="block text-sm font-semibold text-gray-700 mb-2">Job Title *</label>
                                            <input
                                                required
                                                onChange={handleChange}
                                                value={Career.name}
                                                name='name'
                                                type="text"
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
                                                placeholder="e.g., Senior Software Engineer"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-semibold text-gray-700 mb-2">Department *</label>
                                            <select
                                                required
                                                onChange={handleChange}
                                                value={Career.department}
                                                name='department'
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
                                            >
                                                <option value="">Select Department</option>
                                                <option value="Engineering">Engineering</option>
                                                <option value="Design">Design</option>
                                                <option value="Marketing">Marketing</option>
                                                <option value="Sales">Sales</option>
                                                <option value="Product">Product</option>
                                                <option value="Data Science">Data Science</option>
                                                <option value="Operations">Operations</option>
                                                <option value="Other">Other</option>
                                            </select>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-semibold text-gray-700 mb-2">Job Type *</label>
                                            <select
                                                required
                                                onChange={handleChange}
                                                value={Career.jobType}
                                                name='jobType'
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
                                            >
                                                <option value="">Select Type</option>
                                                <option value="Part-Time">Part-Time</option>
                                                <option value="Full-Time">Full-Time</option>
                                                <option value="Remote">Remote</option>
                                                <option value="Contract">Contract</option>
                                                <option value="Internship">Internship</option>
                                            </select>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-semibold text-gray-700 mb-2">Experience Required *</label>
                                            <input
                                                required
                                                onChange={handleChange}
                                                value={Career.experience}
                                                name='experience'
                                                type="text"
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
                                                placeholder="e.g., 3-5 years"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-semibold text-gray-700 mb-2">Location *</label>
                                            <input
                                                required
                                                onChange={handleChange}
                                                value={Career.location}
                                                name='location'
                                                type="text"
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
                                                placeholder="e.g., Remote, New York"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-semibold text-gray-700 mb-2">Posted Date *</label>
                                            <input
                                                required
                                                onChange={handleChange}
                                                value={Career.postedDate}
                                                name='postedDate'
                                                type="date"
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-semibold text-gray-700 mb-2">Application End Date *</label>
                                            <input
                                                required
                                                onChange={handleChange}
                                                value={Career.applyEndDate}
                                                name='applyEndDate'
                                                type="date"
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
                                            />
                                        </div>

                                        <div className="md:col-span-2">
                                            <label className="block text-sm font-semibold text-gray-700 mb-2">Job Description *</label>
                                            <textarea
                                                name="description"
                                                value={Career.description}
                                                onChange={handleChange}
                                                rows={3}
                                                required
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
                                                placeholder="Describe the role..."
                                            />
                                        </div>

                                        <div className="md:col-span-2">
                                            <label className="block text-sm font-semibold text-gray-700 mb-2">Responsibilities *</label>
                                            <textarea
                                                name="responsibilities"
                                                value={Career.responsibilities}
                                                onChange={handleChange}
                                                rows={3}
                                                required
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
                                                placeholder="Key responsibilities..."
                                            />
                                        </div>

                                        <div className="md:col-span-2">
                                            <label className="block text-sm font-semibold text-gray-700 mb-2">Requirements *</label>
                                            <textarea
                                                name="requirements"
                                                value={Career.requirements}
                                                onChange={handleChange}
                                                rows={3}
                                                required
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
                                                placeholder="Required skills and qualifications..."
                                            />
                                        </div>

                                        <div className="md:col-span-2">
                                            <label className="block text-sm font-semibold text-gray-700 mb-2">Benefits</label>
                                            <textarea
                                                name="benefits"
                                                value={Career.benefits}
                                                onChange={handleChange}
                                                rows={2}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
                                                placeholder="Benefits offered..."
                                            />
                                        </div>

                                        <div className="md:col-span-2 flex items-center justify-between bg-gray-50 p-4 rounded-lg">
                                            <label className="text-sm font-semibold text-gray-700">Show on Career Page</label>
                                            <label className="relative inline-flex items-center cursor-pointer">
                                                <input
                                                    onChange={handleCheckBox}
                                                    checked={Career.show}
                                                    name='show'
                                                    type="checkbox"
                                                    className="sr-only peer"
                                                />
                                                <div className="w-14 h-7 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-green-500"></div>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="flex gap-3 pt-4">
                                        <button
                                            type='submit'
                                            disabled={loading}
                                            className="flex-1 bg-primary hover:bg-primary-600 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed shadow-md hover:shadow-lg"
                                        >
                                            {loading ? 'Processing...' : buttonType === "UPDATE" ? 'Update Job' : 'Add Job'}
                                        </button>
                                        <button
                                            type='button'
                                            onClick={closeModal}
                                            className="px-6 py-3 border-2 border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-all duration-200"
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )}

                    {/* Sidebar View Details */}
                    {showSidebar && viewCareer && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-end" onClick={() => setShowSidebar(false)}>
                            <div
                                className="bg-white w-full max-w-2xl h-full overflow-y-auto shadow-2xl animate-slideInRight"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <div className="sticky top-0 bg-gradient-to-r from-primary to-primary-600 text-white p-6 flex justify-between items-center">
                                    <h4 className="text-2xl font-bold">{viewCareer.name}</h4>
                                    <button
                                        onClick={() => setShowSidebar(false)}
                                        className="text-white hover:bg-white hover:bg-opacity-20 rounded-full p-2 transition-all"
                                    >
                                        <AiIcons.AiOutlineClose size={24} />
                                    </button>
                                </div>

                                <div className="p-6 space-y-6">
                                    <div className="flex items-center justify-between bg-gray-50 p-4 rounded-lg">
                                        <span className="font-semibold text-gray-700">Visibility Status</span>
                                        <span className={`px-4 py-2 rounded-full font-semibold ${viewCareer.show ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                                            {viewCareer.show ? 'Active' : 'Inactive'}
                                        </span>
                                    </div>

                                    <div className="grid grid-cols-2 gap-4">
                                        <div className="bg-blue-50 p-4 rounded-lg">
                                            <p className="text-sm text-gray-600 mb-1">Job Type</p>
                                            <p className="font-semibold text-gray-900">{viewCareer.jobType}</p>
                                        </div>
                                        <div className="bg-purple-50 p-4 rounded-lg">
                                            <p className="text-sm text-gray-600 mb-1">Experience</p>
                                            <p className="font-semibold text-gray-900">{viewCareer.experience}</p>
                                        </div>
                                        <div className="bg-green-50 p-4 rounded-lg">
                                            <p className="text-sm text-gray-600 mb-1">Location</p>
                                            <p className="font-semibold text-gray-900">{viewCareer.location}</p>
                                        </div>
                                        <div className="bg-orange-50 p-4 rounded-lg">
                                            <p className="text-sm text-gray-600 mb-1">Posted Date</p>
                                            <p className="font-semibold text-gray-900">{formatDate(viewCareer.postedDate)}</p>
                                        </div>
                                    </div>

                                    <div className="space-y-4">
                                        <div>
                                            <h5 className="font-bold text-gray-900 mb-2 text-lg">Description</h5>
                                            <p className="text-gray-700 leading-relaxed">{viewCareer.description}</p>
                                        </div>

                                        <div>
                                            <h5 className="font-bold text-gray-900 mb-2 text-lg">Responsibilities</h5>
                                            <p className="text-gray-700 leading-relaxed whitespace-pre-line">{viewCareer.responsibilities}</p>
                                        </div>

                                        <div>
                                            <h5 className="font-bold text-gray-900 mb-2 text-lg">Requirements</h5>
                                            <p className="text-gray-700 leading-relaxed whitespace-pre-line">{viewCareer.requirements}</p>
                                        </div>

                                        {viewCareer.benefits && (
                                            <div>
                                                <h5 className="font-bold text-gray-900 mb-2 text-lg">Benefits</h5>
                                                <p className="text-gray-700 leading-relaxed whitespace-pre-line">{viewCareer.benefits}</p>
                                            </div>
                                        )}
                                    </div>

                                    <div className="bg-red-50 border border-red-200 p-4 rounded-lg">
                                        <p className="text-sm text-gray-600 mb-1">Application Deadline</p>
                                        <p className="font-bold text-red-600">{formatDate(viewCareer.applyEndDate)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}
        </>
    )
}

export default ManageCareer